import React, { useState } from "react";
import { useTeamContext } from "store/contexts/teamContext";
import TaskShare from "../TaskShare";
import TaskDelete from "./TaskDelete";

export default ({ listTask }) => {
  const { team } = useTeamContext();
  const [canDelete] = useState(canDeleteTask);
  const [canShare] = useState(canShareTask);

  function canDeleteTask() {
    if (!listTask?.is_forwarded && [3, 2].includes(team?.role_id)) {
      return true;
    }

    return false;
  }

  function canShareTask() {
    if (listTask?.is_forwarded) {
      return false;
    }

    return true;
  }

  return (
    <div className="right-actions">
      {canShare && <TaskShare myteam_id={team?.id} listTask={listTask} />}
      {canDelete && <TaskDelete listTask={listTask} />}
    </div>
  );
};
